module.exports = __webpack_public_path__ + "static/media/相聚里2.af29209b.png";